var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Change Home Path ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "pb-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _vm._v("Change account "),
                            _c("strong", [_vm._v(_vm._s(_vm.account.user))]),
                            _vm._v(" home path.")
                          ]
                        )
                      ]
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("autocomplete-dir", {
                          attrs: {
                            "with-prefix": ""
                          },
                          model: {
                            value: _vm.dir,
                            callback: function callback($$v) {
                              _vm.dir = $$v
                            },
                            expression: "dir"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.closeModal
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  type: "submit",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.saveHomedir
                }
              },
              [_vm._v(" Change ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }